import { defineComponent, h } from 'vue';

import { useInjectExpandedRow, useInjectTable } from '../../context';
import { Cell } from '../Cell';

import type { NTable } from '../../interface';

interface IExpandRowProps {
  component: NTable.NCustomize.TCustomizeComponent;
  cellComponent: NTable.NCustomize.TCustomizeComponent;
  expanded: boolean;
  colSpan: number;
  isEmpty: boolean;
}

export default defineComponent<IExpandRowProps>({
  name: 'ExpandedRow',
  inheritAttrs: false,
  props: ['component', 'cellComponent', 'expanded', 'colSpan', 'isEmpty'] as any,
  setup(props, { slots, attrs }) {
    const tableContext = useInjectTable();
    const expandedRowContext = useInjectExpandedRow();
    const { fixHeader, fixColumn, componentWidth, horizonScroll } = expandedRowContext;

    return () => {
      const { component: Component, cellComponent, expanded, colSpan, isEmpty } = props;

      return h(
        Component,
        { class: attrs.class, style: { display: expanded ? null : 'none' } },
        h(
          Cell,
          { component: cellComponent, colSpan },
          {
            default: () => {
              if (isEmpty ? horizonScroll.value : fixColumn.value) {
                return h(
                  'div',
                  {
                    style: {
                      width: `${componentWidth.value - (fixHeader.value ? tableContext.scrollbarSize : 0)}px`,
                      position: 'sticky',
                      left: 0,
                      overflow: 'hidden'
                    },
                    class: 'cds-table__expanded-row-fixed'
                  },
                  slots.default?.()
                );
              }

              return slots.default?.();
            }
          }
        )
      );
    };
  }
});
